import React from 'react';

const Divider = () => <div style={{ height: 10 }} />;

export default Divider;



// WEBPACK FOOTER //
// ./src/shared/Divider.jsx